import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import EnjoyPage from '../pages/enjoy/page';
import ProductDetailPage from '../pages/enjoy/product-detail/page';
import AboutPage from '../pages/about/page';
import MissionVisionValuesPage from '../pages/mission-vision-values/page';
import NutrarePage from '../pages/nutrare/page';
import NutrareProductDetailPage from '../pages/nutrare/product-detail/page';
import NotFound from '../pages/NotFound';
import EventosCorporativosPage from '../pages/eventos-corporativos/page';
import AniversariosSustentarePage from '../pages/aniversarios-sustentare/page';
import DiaDasCriancasPage from '../pages/dia-das-criancas/page';
import NossoNatalPage from '../pages/nosso-natal/page';
import NoticiasPage from '../pages/noticias/page';
import NoticiaDetailPage from '../pages/noticias/detail/page';
import ContatoPage from '../pages/contato/page';
import ProgramasIncentivosPage from '../pages/programas-incentivos/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/mission-vision-values',
    element: <MissionVisionValuesPage />,
  },
  {
    path: '/enjoy',
    element: <EnjoyPage />,
  },
  {
    path: '/enjoy/product-detail/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/enjoy/produto/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/nutrare',
    element: <NutrarePage />,
  },
  {
    path: '/nutrare/product-detail/:id',
    element: <NutrareProductDetailPage />,
  },
  {
    path: '/nutrare/produto/:id',
    element: <NutrareProductDetailPage />,
  },
  {
    path: '/eventos-corporativos',
    element: <EventosCorporativosPage />,
  },
  {
    path: '/aniversarios-sustentare',
    element: <AniversariosSustentarePage />,
  },
  {
    path: '/dia-das-criancas',
    element: <DiaDasCriancasPage />,
  },
  {
    path: '/nosso-natal',
    element: <NossoNatalPage />,
  },
  {
    path: '/noticias',
    element: <NoticiasPage />,
  },
  {
    path: '/noticias/:id',
    element: <NoticiaDetailPage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '/programas-incentivos',
    element: <ProgramasIncentivosPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;